"use client";

import React from "react";
import { Button } from "@/components/ui/button";

interface ErrorBoundaryDefaultFallbackProps {
  error?: Error;
  errorInfo?: React.ErrorInfo;
  resetError: () => void;
}

export function ErrorBoundaryDefaultFallback({
  error,
  errorInfo,
  resetError,
}: ErrorBoundaryDefaultFallbackProps) {
  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-background">
      <div className="max-w-lg w-full">
        <div className="bg-card border border-border rounded-lg p-8 shadow-sm">
          <div className="text-center">
            <div className="w-16 h-16 bg-destructive/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-red-500 text-2xl">⚠️</span>
            </div>
            <h1 className="text-2xl font-bold text-foreground mb-2">
              Something went wrong
            </h1>
            <p className="text-muted-foreground mb-6">
              Something went wrong. Please refresh the page.
            </p>

            {process.env.NODE_ENV === "development" && error && (
              <details className="text-left bg-muted rounded p-4 mb-4">
                <summary className="cursor-pointer text-sm font-medium text-muted-foreground mb-2">
                  Error Details (Development)
                </summary>
                <pre className="text-xs text-error overflow-auto">
                  {error.toString()}
                  {errorInfo?.componentStack}
                </pre>
              </details>
            )}

            <div className="flex gap-4 justify-center">
              <Button onClick={resetError} variant="primary" size="md">
                Try again
              </Button>
              <Button
                onClick={() => window.location.reload()}
                variant="secondary"
                size="md"
              >
                Refresh page
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
